import React from 'react';
import { FieldArray, useField } from 'formik';
import cn from 'classnames';
import { ListOptions } from '../data/dataType';
import Select from '../ui/Select';

type ListInputProps = {
    name: string;
    placeholder?: string;
    label?: string;
    editable?: boolean;
    options?: ListOptions[];
    onChange?: (value: string | number | null) => void;
};

const ListInput: React.FC<ListInputProps> = ({
    name,
    placeholder = 'Ajouter une valeur',
    label,
    editable = true,
    options = [],
    onChange,
}) => {
    const [field, meta, helpers] = useField(name);

    if (!editable) {
        return (
            <div>
                <Select
                    className="w-full"
                    name={name}
                    onChange={value => {
                        helpers.setValue(value);
                        if (onChange) {
                            onChange(value);
                        }
                    }}
                    options={options}
                    placeholder={placeholder}
                />
                {meta.touched && meta.error && (
                    <p className="mt-2 text-red-600">{meta.error}</p>
                )}
            </div>
        );
    }

    return (
        <div className="mb-4">
            {label && (
                <label
                    className="block font-medium text-gray-700 mb-2"
                    htmlFor={name}
                >
                    {label}
                </label>
            )}
            <FieldArray
                name={name}
                render={arrayHelpers => (
                    <div>
                        {field.value && field.value.length > 0 ? (
                            field.value.map((item: string, index: number) => (
                                <div
                                    className="flex items-center mb-2"
                                    key={index}
                                >
                                    <input
                                        className={cn(
                                            'w-full bg-white border border-gray-300 text-gray-900 rounded-lg focus:ring-primary focus:border-primary block p-2',
                                            meta.touched &&
                                                meta.error &&
                                                'bg-red-50',
                                        )}
                                        onChange={e => {
                                            const newValue = [...field.value];
                                            newValue[index] = e.target.value;
                                            helpers.setValue(newValue);
                                        }}
                                        placeholder={placeholder}
                                        type="text"
                                        value={item}
                                    />
                                    <button
                                        className="ml-2 px-3 py-1 text-white bg-red-500 rounded-lg hover:bg-red-600"
                                        onClick={() =>
                                            arrayHelpers.remove(index)
                                        }
                                        type="button"
                                    >
                                        Supprimer
                                    </button>
                                </div>
                            ))
                        ) : (
                            <p className="text-gray-500">
                                Aucune valeur pour l&apos;instant.
                            </p>
                        )}
                        <button
                            className="mt-2 px-4 py-2 text-white bg-blue-500 rounded-lg hover:bg-blue-600"
                            onClick={() => arrayHelpers.push('')}
                            type="button"
                        >
                            Ajouter une valeur
                        </button>
                    </div>
                )}
            />
            {meta.touched && meta.error && (
                <p className="mt-2 text-red-600">{meta.error}</p>
            )}
        </div>
    );
};

export default ListInput;
